import React from 'react'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';


export default function ContactHome() {


    return (

        <>

            <div className='bg-[#539d56] mx-4 md:mx-24 mt-4 rounded-2xl relative'>

                <div className='md:h-60 h-auto bg-transparent py-4 flex flex-wrap justify-center items-center gap-20' style={{ backgroundImage: `url("./Images/Home/contact-bg.png")` }}>

                    <div className='bg-transparent flex items-center px-4 gap-2'>

                        <p className='w-20 h-20 bg-orange-500 md:flex hidden flex justify-center items-center rounded-[50%]'><EmailOutlinedIcon sx={{ bgcolor: "transparent", color: "white", fontSize: "38px", }} /> </p>

                        <div className='bg-transparent '>
                            <p className='bg-transparent opacity-50 text-white text-xl'> Mail For Information</p>
                            <p className='bg-transparent text-white text-2xl md:text-3xl'>info@arundhatiexim.com</p>

                        </div>
                    </div>

                    <h2 className='bg-transparent text-5xl text-white md:w-[35%] md:p-0 px-12'>Get in touch with us
                        for Consultancy</h2>

                    <button className='bg-orange-500 hover:bg-orange-400 text-white px-8  py-2 rounded-lg'> <LocalPhoneOutlinedIcon sx={{ bgcolor: "transparent", }} /> Contact Us </button>

                </div>
            </div>

        </>
    );
}